import { USER_ROLE } from '@socialive/common';
import { Button, Modal } from '@socialive/ui';
import PropTypes from 'prop-types';
import RoleUsage from './RoleUsage';

const ROLE_LIST = [
  USER_ROLE.GUEST,
  USER_ROLE.CONTRIBUTOR,
  USER_ROLE.CREATOR,
  USER_ROLE.PRODUCER,
  USER_ROLE.BROADCASTER,
  USER_ROLE.ADMIN,
];

const RolesLicensingModal = ({ modal }) => (
  <Modal
    title="Usage"
    visible
    onCancel={modal.close}
    width={600}
    onCloseButtonClick={modal.close}
    footer={
      <Button context="primary" onClick={modal.close} className="ml-auto" size="small">
        OK
      </Button>
    }
  >
    <div className="w-full grid grid-cols-3 pt-3 pb-3">
      {ROLE_LIST.map((role) => (
        <RoleUsage key={role} role={role} />
      ))}
    </div>
  </Modal>
);

RolesLicensingModal.propTypes = {
  modal: PropTypes.shape({
    visible: PropTypes.bool,
    open: PropTypes.func,
    update: PropTypes.func,
    close: PropTypes.func,
  }).isRequired,
};

export default RolesLicensingModal;
